import { useState } from "react";
import { useNavigate } from "react-router-dom";
import KanbanCard from "./KanbanCard";
import { navegarComCtrl } from "../../../utils/solicitacoes/navegacao";

// Com muitas solicitações, renderizar (e buscar o detalhe de) todos os cards de uma vez trava a
// página — cada coluna mostra um lote por vez, com "Mostrar mais".
const CARDS_POR_LOTE = 30;

// React + Tailwind puro, sem lib de kanban. Sem drag & drop nesta versão.
// `detalhesPorId` (opcional): detalhes já buscados pela tela — quando informado, os cards não
// buscam o detalhe de novo (evita uma segunda chamada por card).
export default function KanbanBoard({ etapas = [], solicitacoes = [], detalhesPorId }) {
    const navigate = useNavigate();
    const [limitePorColuna, setLimitePorColuna] = useState({});

    const colunas = [
        ...etapas,
        { codigo: "__FINALIZADA__", label: "Finalizadas" },
        { codigo: "__CANCELADA__", label: "Canceladas" },
    ];

    function solicitacoesDaColuna(coluna) {
        if (coluna.codigo === "__FINALIZADA__") return solicitacoes.filter(s => s.status === "FINALIZADA");
        if (coluna.codigo === "__CANCELADA__") return solicitacoes.filter(s => s.status === "CANCELADA");
        return solicitacoes.filter(s => s.etapaAtual === coluna.codigo);
    }

    function mostrarMais(codigo) {
        setLimitePorColuna(prev => ({ ...prev, [codigo]: (prev[codigo] || CARDS_POR_LOTE) + CARDS_POR_LOTE }));
    }

    return (
        <div className="flex gap-3 overflow-x-auto pb-3">
            {colunas.map(coluna => {
                const itens = solicitacoesDaColuna(coluna);
                const limite = limitePorColuna[coluna.codigo] || CARDS_POR_LOTE;
                const visiveis = itens.slice(0, limite);
                return (
                    <div key={coluna.codigo} className="w-72 shrink-0 bg-muted rounded-lg p-2.5">
                        <div className="flex items-center justify-between px-1 mb-2">
                            <h3 className="text-xs font-semibold text-foreground uppercase tracking-wide">{coluna.label}</h3>
                            <span className="text-[10px] bg-card border border-border rounded-full px-1.5 py-0.5 text-muted-foreground font-semibold">
                                {itens.length}
                            </span>
                        </div>

                        <div className="flex flex-col gap-2 max-h-[70vh] overflow-y-auto pr-0.5">
                            {itens.length === 0 ? (
                                <p className="text-xs text-muted-foreground text-center py-4">Nenhuma solicitação</p>
                            ) : (
                                visiveis.map(s => (
                                    <KanbanCard
                                        key={s.id}
                                        solicitacao={s}
                                        {...(detalhesPorId ? { detalhe: detalhesPorId[s.id] || null, autoDetalhe: false } : {})}
                                        onClick={e => navegarComCtrl(navigate, `/solicitacoes/${s.id}`, e)}
                                    />
                                ))
                            )}
                            {itens.length > visiveis.length && (
                                <button
                                    type="button"
                                    onClick={() => mostrarMais(coluna.codigo)}
                                    className="text-xs font-semibold text-primary hover:bg-primary/10 rounded-md py-2"
                                >
                                    Mostrar mais ({itens.length - visiveis.length} restantes)
                                </button>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
